import { Box, FloraButton, Grid, FloraInput, FloraTypography } from '@grupoboticario/flora-react'

import { containerStyles, gridStyles, textareaStyles, characterCounterStyles, deleteButtonStyles } from './styles'

const FAQItem = ({
  index,
  question = '',
  answer = '',
  maxQuestionLength = 200,
  maxAnswerLength = 500,
  onQuestionChange,
  onAnswerChange,
  onDelete,
  canDelete = true
}) => {
  return (
    <Box css={containerStyles}>
      <Grid css={gridStyles}>
        <Box>
          <FloraInput
            aria-label={`Question ${index + 1}:`}
            as="textarea"
            css={textareaStyles}
            label={`Question ${index + 1}:`}
            onChange={(e) => onQuestionChange(e.target.value)}
            size="medium"
            value={question || ''}
          />
          <FloraTypography fontSize="exceptionsRestricted" css={characterCounterStyles}>
            {(question || '').length}/{maxQuestionLength}
          </FloraTypography>
        </Box>

        <Box>
          <FloraInput
            as="textarea"
            css={textareaStyles}
            label="Answer:"
            onChange={(e) => onAnswerChange(e.target.value)}
            size="medium"
            value={answer || ''}
          />
          <FloraTypography fontSize="exceptionsRestricted" css={characterCounterStyles}>
            {(answer || '').length}/{maxAnswerLength}
          </FloraTypography>
        </Box>

        <FloraButton
          css={deleteButtonStyles}
          disabled={!canDelete}
          onClick={onDelete}
          type="button"
          has="iconLeft"
          icon={<Box as="img" src="/img/trash.svg" alt="Excluir pergunta" />}
        >
          Excluir pergunta
        </FloraButton>
      </Grid>
    </Box>
  )
}

export default FAQItem
